module.exports = __webpack_public_path__ + "media/images/step-1-c80dccc8fd386f345796b931239b3b5e.png";